import { Button } from 'components/atoms';
import { useTableDropdown } from 'hooks/useTableDropdown';
import { ReactNode, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { createPortal } from 'react-dom';
import { PiDotsThreeVerticalBold } from 'react-icons/pi';
import {
  IChildrenProp,
  IJustifyPositionProps,
} from 'types/components/components.interface';
import './TableDropdown.scss';

interface ITableDropdownProps extends IChildrenProp, IJustifyPositionProps {
  trigger?: ReactNode;
  description?: string;
  isLoading?: boolean;
  style?: React.CSSProperties;
}

const TableDropdown = ({
  children,
  trigger,
  description,
  isLoading,
  justifyPosition = 'end',
  style,
}: ITableDropdownProps) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const toggle = useCallback(() => {
    setIsOpen(previous => !previous);
  }, []);

  const { triggerRef, menuRef, position } = useTableDropdown({
    isOpen,
    onClose: close,
    justifyPosition,
  });

  return (
    <>
      <div ref={triggerRef} className='table-dropdown-trigger'>
        {trigger ?? (
          <Button
            type='button'
            isClear
            onlyIcon
            isLoading={isLoading}
            onClick={toggle}>
            <Button.Description
              description={description ?? t('button.more-options')}
            />
            <Button.Icon icon={<PiDotsThreeVerticalBold />} />
          </Button>
        )}
      </div>
      {isOpen &&
        createPortal(
          <div
            ref={menuRef}
            className='table-dropdown-menu'
            style={{
              top: position?.top ?? -9999,
              left: position?.left ?? -9999,
              visibility: position ? 'visible' : 'hidden',
              ...style,
            }}>
            {children}
          </div>,
          document.body
        )}
    </>
  );
};

export default TableDropdown;
